import React, { useState, useEffect } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { testimonials } from '../data';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsToShow(1);
      } else if (window.innerWidth < 1024) {
        setItemsToShow(2);
      } else {
        setItemsToShow(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const next = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex + 1 >= testimonials.length - (itemsToShow - 1) ? 0 : prevIndex + 1
    );
  };

  const prev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex - 1 < 0 ? testimonials.length - itemsToShow : prevIndex - 1
    );
  };

  return (
    <section className="pt-20 pb-16 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl md:text-4xl font-bold text-[#103B66] mb-4">
              Det siger vores kunder
            </h2>
            <p className="text-lg text-slate-600">
              Vi er stolte af at hjælpe borgere med at få en tryggere digital hverdag. Her er et udpluk af deres oplevelser.
            </p>
          </div>
          
          <div className="flex gap-2">
            <button 
              onClick={prev}
              className="p-3 rounded-none border border-slate-200 hover:bg-slate-50 transition-colors text-[#103B66]"
              aria-label="Forrige anmeldelse"
            >
              <ChevronLeft size={24} />
            </button>
            <button 
              onClick={next}
              className="p-3 rounded-none border border-slate-200 hover:bg-slate-50 transition-colors text-[#103B66]"
              aria-label="Næste anmeldelse"
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>

        <div className="relative">
          <div className="overflow-hidden -mx-4 px-4 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 py-8">
            <motion.div 
              className="flex gap-8"
              animate={{ x: `calc(-${currentIndex * (100 / itemsToShow)}% - ${currentIndex * (32 / itemsToShow)}px)` }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              {testimonials.map((testimonial, index) => (
                <div 
                  key={index} 
                  className="flex-shrink-0 w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-21.33px)]"
                >
                  <div className="bg-white p-8 rounded-none flex flex-col h-full shadow-lg border border-slate-100 hover:shadow-xl transition-shadow duration-300">
                    <div className="flex mb-4">
                      {[...Array(testimonial.stars)].map((_, i) => (
                        <Star key={i} size={18} className="text-yellow-400 fill-yellow-400" />
                      ))}
                    </div>

                    <blockquote className="text-slate-700 italic mb-6 flex-grow">
                      "{testimonial.quote}"
                    </blockquote>

                    <div className="mt-auto pt-6 border-t border-slate-200">
                      <p className="font-bold text-[#103B66]">{testimonial.name}</p>
                      <p className="text-sm text-slate-500">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
